@if (bulletins) {
<div class="bulletin-box">
    @for (bulletin of bulletins; track bulletin) { @if (bulletin.read === false) {
    <div class="bulletin">
        @if (bulletin.global === false) {
        <i class="fa fa-times" (click)="deleteBulletin(bulletin._id); bulletin.read = true"></i>
        }
        <div>{{ bulletin.body }}</div>
    </div>
    } }
</div>
}
